export var ModelType;
(function (ModelType) {
    ModelType["BIOCLIMATIC"] = "BIOCLIMATIC";
    ModelType["PVC"] = "PVC";
})(ModelType || (ModelType = {}));
export class Model {
    constructor(id, type, name, description, maxWidth, minWidth, maxProjection, minProjection, extras) {
        this.id = id;
        this.type = type;
        this.name = name;
        this.description = description;
        this.maxWidth = maxWidth;
        this.minWidth = maxWidth;
        this.maxProjection = maxProjection;
        this.minProjection = maxProjection;
        this.extras = extras;
    }
}
export class MeasuredModel {
    constructor(model, width, projection, quantity, rotated, canRotate, modulesX, modulesZ) {
        this.model = model;
        this.width = width;
        this.projection = projection;
        this.quantity = quantity;
        this.rotated = rotated;
        this.canRotate = canRotate;
        this.modulesX = modulesX;
        this.modulesZ = modulesZ;
    }
}
export const skyroofPlus = new Model(4, ModelType.BIOCLIMATIC, "Skyroof Plus", "asdasd", 450, 200, 799, 200, []);
